import moment from "moment/moment";

/**
 *Created by jmmartinez on 6/8/18
 * v 1.1 16/06/2019 Añadida función getFormattedDateHyphenFromTimestamp
 *                  Añadida función getDateFromFormattedStringHyphensAndTime
 * v 1.2 11/09/2019 Añadida funcion getDateTimeFromFormattedString
 * v 1.3 25/09/2019 Añadida funcion getTimestampFromNowSinHora
 * v 1.4 21/10/2019 Añadida funcion getTimestampFromTimestampHora
 * v.1.5 04/11/2019 Añadida funcion getPeriodoUltimoMes
 * v.1.6 27/03/2020 Añadida función getFormattedDateTimeFromCadenaISO
 *                  Añadida función getMinutosEntreDates
 **/

export const getDateFromTimestamp = (valueTimestamp) => {

    return moment.unix(valueTimestamp / 1000);

}

export const getTimestampFromNow = () => {
    let dateAhora= new Date();
    return dateAhora.getTime();
}

export const getTimestampFromNowSinHora = () => {
    let dateAhora= new Date();
    dateAhora.setHours(0);
    dateAhora.setMinutes(0);
    dateAhora.setSeconds(0);
    dateAhora.setMilliseconds(0);
    return dateAhora.getTime();
}

export const getTimestampFromDate = (valueDate) => {
    return valueDate.getTime();
}

export const getTimestampFromTimestampHora = (fechaTimestamp, horaCadena) => {
    if (fechaTimestamp && horaCadena) {
        let componentesHora = horaCadena.split(":");
        const dateResultado= new Date(fechaTimestamp);
        dateResultado.setHours(componentesHora[0]);
        dateResultado.setMinutes(componentesHora[1]);
        dateResultado.setSeconds(0);
        dateResultado.setMilliseconds(0);
        return dateResultado.getTime();
    }
}

export const getFormattedISO8601FromTimestamp = (value) => {
    if (value) {
        const date = moment.unix(value / 1000);
        value = date.toISOString();
    }
    return value;
}

export const getFormattedDateFromTimestamp = (value) => {
    if (value) {
        const date = moment.unix(value / 1000);
        value = date.format("DD/MM/YYYY");
    }
    return value;
}

export const getFormattedDateHyphenFromTimestamp = (value) => {
    if (value) {
        const date = moment.unix(value / 1000);
        value = date.format("DD-MM-YYYY");
    }
    return value;
}


export const getFormattedDateFromDate = (value) => {
    if (value) {
        return getFormattedDateFromTimestamp (value.getTime());
    }
    return value;
}

export const getFormattedDateTimeFromDate = (value) => {
    if (value) {
        return getFormattedDateTimeFromTimestamp (value.getTime());
    }
    return value;
}

export const getFormattedDateTimeFromTimestamp = (value) => {
    if (value) {
        const date = moment.unix(value / 1000);
        value = date.format("DD/MM/YYYY HH:mm:ss");
    }
    return value;
}

export const getFormattedDateTimeMinutesFromTimestamp = (value) => {
    if (value) {
        const date = moment.unix(value / 1000);
        value = date.format("DD/MM/YYYY HH:mm");
    }
    return value;
}

export const getFormattedDateTimeFromCadenaISO = (cadena) => {
    let date = new Date(cadena);
    let cadenaISO = getFormattedDateTimeFromDate(date);
    return cadenaISO;
}
export const getFormattedTimeFromTimestamp = (value) => {
    if (value) {
        const date = moment.unix(value / 1000);
        value = date.format("HH:mm");
    }
    return value;
}

export const getDayMonthDayOfWeekFromTimestamp = (value) => {
    if (value) {
        const date = moment.unix(value / 1000);
        let day = parseInt(date.format("DD"), 10);
        let month= parseInt(date.format("MM"), 10);
        let dayOfWeek= date.day();
        return {day: day, month: month, dayOfWeek: dayOfWeek};
    }
    return null;
}

export const getFormattedDateTimeNow = () => {
    return getFormattedDateTimeFromTimestamp(Date.now());
}

export const getFormattedDateTimeAhoraForFile = () => {
    let ahora= Date.now();
    const date = moment.unix(ahora / 1000);
    let value = date.format("YYYYMMDD_HHmmss");
    return value;
}


export const getMinutosHastaAhora = (stringAntes) => {
    var stringAhora= getFormattedDateTimeNow();
    return getMinutosEntreFechas(stringAntes, stringAhora);
}

export const getMinutosEntreFechas = (stringAntes, stringDespues) => {
    var momentAntes= moment(stringAntes, "DD/MM/YYYY HH:mm:ss");
    let momentDespues= moment(stringDespues, "DD/MM/YYYY HH:mm:ss");
    let difMinutos= momentDespues.diff(momentAntes, "minutes");
    return difMinutos;
}

export const getMinutosEntreDates = (dateAntes, dateDespues) => {
    let diff = dateDespues - dateAntes;
    let diffMinutos = diff/(1000*60);
    return Math.abs(diffMinutos);
}


export const getDayName = (day) => {
    switch (day){
        case 0: return "Domingo";
        case 1: return "Lunes";
        case 2: return "Martes";
        case 3: return "Miércoles";
        case 4: return "Jueves";
        case 5: return "Viernes";
        case 6: return "Sábado";
        default: return "-";
    }
}


//Formato esperado de entrada hh:mm
export const getTimeFromFormattedString = (timeStr) => {
    if (!timeStr)
        return null;
    var parts = timeStr.split(":");
    let hora= new Date();
    hora.setHours(parts[0]);
    hora.setMinutes(parts[1]);
    hora.setSeconds(0);
    return hora;
}

export const getStringFromDate = (date) => {
    if (date) {
        return moment(date).format("DD/MM/YYYY");
    }
    return "";
}

//Formato esperado de entrada dd/mm/yyyy
export const getDateFromFormattedString = (dateStr) => {
    if (!dateStr)
        return null;
    var parts = dateStr.split("/");
    return new Date(parts[2], parts[1] - 1, parts[0])
}

//Formato esperado de entrada dd/mm/yyyy hh:mm:ss
export const getDateTimeFromFormattedString = (dateStr) => {
    if (!dateStr)
        return null;
    var parts = dateStr.split(" ");

    var dateParts= parts[0].split("/");
    var timeParts= parts[1].split(":");
    return new Date(dateParts[2], dateParts[1] - 1, dateParts[0], timeParts[0], timeParts[1], timeParts[2], 0);
}

//Formato esperado de entrada de fecha dd-mm-yyyy y hora hh:mm
export const getDateFromFormattedStringHyphensAndTime = (dateStr, timeStr) => {
    var dateParts=  dateStr.split("-");
    var timeParts= timeStr.split(":");
    return new Date(dateParts[2], dateParts[1] - 1, dateParts[0], timeParts[0], timeParts[1], 0, 0)
}

export const esCorrectaDateFormattedString = (dateStr) => {
    if (!dateStr)
        return false;
    var parts = dateStr.split("/");
    console.log(parts);
    return parts.length === 3 && parts[0].length === 2 && parts[1].length === 2 && parts[2].length === 4;
}


export const addDias= (date, dias) => {
    if (date){
        var dateNueva = new Date(date);
        dateNueva.setDate(date.getDate() + dias);
        return dateNueva;
    }
}

export const getPeriodoMesActual= () => {
    var hoy= new Date();
    var desde = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
    var hasta = new Date(hoy.getFullYear(), hoy.getMonth() + 1, 0);
    return {desde: desde, hasta: hasta};
}

export const getPeriodoAgnoActual= () => {
    var hoy= new Date();
    var desde = new Date(hoy.getFullYear(), 0, 1);
    var hasta = new Date(hoy.getFullYear(), 12, 0);
    return {desde: desde, hasta: hasta};
}

export const getPeriodoMes= (mes) => {
    var hoy= new Date();
    var desde = new Date(hoy.getFullYear(), mes-1, 1);
    var hasta = new Date(hoy.getFullYear(), mes, 0);
    return {desde: desde, hasta: hasta};

}

export const getPeriodoTrimestre= (trimestre) => {
    var hoy= new Date();
    var mesInicio= ((trimestre -1 ) * 3);
    var mesFin= trimestre * 3;
    var desde = new Date(hoy.getFullYear(), mesInicio, 1);
    var hasta = new Date(hoy.getFullYear(), mesFin, 0);
    return {desde: desde, hasta: hasta};

}


export const getPeriodoUltimaSemana= () => {
    var hoy= new Date();
    var haceUnaSemana = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate() - 7);
    //var haceUnaSemana2= new Date(hoy.getTime() - 7 * 24 * 60 * 60 * 1000);
    return {desde: haceUnaSemana, hasta: hoy};
}


export const getPeriodoUltimoMes= () => {
    var hoy= new Date();
    var haceUnMes = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate() - 30);
    //var haceUnaSemana2= new Date(hoy.getTime() - 7 * 24 * 60 * 60 * 1000);
    return {desde: haceUnMes, hasta: hoy};
}

/*
export const getPeriodoAgnoActual = () => {
    let value = Date.now().format("YYYY");
    var momentDesde= moment("01/01/" + value, "DD/MM/YYYY");
    var momentHasta= moment("31/12/" + value, "DD/MM/YYYY");
    return {desde: momentDesde, hasta: momentHasta};
}

export const getPeriodoMesActual = () => {
    let value = Date.now().format("YYYY");
    var momentDesde= moment("01/01/" + value, "DD/MM/YYYY");
    var momentHasta= moment("31/12/" + value, "DD/MM/YYYY");
    return {desde: momentDesde, hasta: momentHasta};
}

 */